import React from 'react'
import Card from 'containers/list/products/single_product_card'

const ProductCard = ({ product }) => {
  return (
    <Card
      {...product}
      height="165"
      hideWrapper
      newWindow
    />
  )
}

export default ProductCard